<header class="dashboard mobile settings">
    <div>
        <mat-icon svgIcon="ss-logo" class="logo-img" routerLink="/dashboard-mobile"></mat-icon>
    </div>
    <div class="naviItems">
        {{ "MAIN_APP_SETTINGS.AppEinstellungen" | translate }}
    </div>
    <div class=" burger-menu">
        <button
            ejs-speeddial
            id="speedDialMenu"
            class="mat-basic"
            openIconCss="e-icons e-menu"
            closeIconCss="e-icons e-close"
            position="TopRight"
            (created)="speedMenuCreated()"
            (clicked)="speedMenuClicked($event)"
            [items]="menuItems"></button>
    </div>
</header>

<main class="mobile no-footer">

    <mat-accordion class="accordion">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.offlineDaten" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <h4>{{ "MAIN_APP_SETTINGS.datenDownload" | translate }}</h4>
            <div id="treeparent">
                <ejs-treeview id="treeelement" #treeoff [fields]="fieldOffline" [showCheckBox]="showCheckBox">
                </ejs-treeview>
            </div>
            <div style="display: flex; gap: 0.5em">
                <button mat-raised-button (click)="webEditionImport()">Import</button>
                <button mat-raised-button (click)="webEditionDeleteOfflineData()">
                    {{ "MAIN_APP_SETTINGS.offlineObjekteLöschen" | translate }}
                </button>

            </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.benutzerEinstellungen" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div>
                <div>
                    <mat-checkbox class="cbDebung-margin" [checked]="webUserConfig.debugMode" (change)="setDebugMode($event.checked)">
                        {{ "MAIN_APP_SETTINGS.debugModus" | translate }}
                    </mat-checkbox>

                    <mat-form-field>
                        <mat-label>
                            {{ "MAIN_APP_SETTINGS.startseite" | translate }}
                        </mat-label>
                        <mat-select [(value)]="startPage" (selectionChange)="dropdownStartPageChange($event)">
                            <mat-option *ngFor="let site of startSites" [value]="site.value">
                                {{ site.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div style="display: flex; gap: 0.5em;">
                        <mat-form-field>
                            <input matInput placeholder="{{
                      'MAIN_APP_SETTINGS.zeitrasterStart' | translate
                    }}" [(ngModel)]="timeGridStart" (input)="onGridStartChange($event)"/>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="{{
                      'MAIN_APP_SETTINGS.zeitrasterEnde' | translate
                    }}" [(ngModel)]="timeGridEnd" (input)="onGridEndChange($event)"/>
                        </mat-form-field>
                    </div>

                    <div style="display: flex; gap: 0.5em;">
                        <mat-form-field>
                            <input matInput placeholder="{{
                      'MAIN_APP_SETTINGS.arbeitstagStart' | translate
                    }}" [(ngModel)]="timeWorkDayStart" (input)="onWorkDayStartChange($event)"/>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="{{
                      'MAIN_APP_SETTINGS.arbeitstagEnde' | translate
                    }}" [(ngModel)]="timeWorkDayEnd" (input)="onWorkDayEndChange($event)"/>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <mat-form-field>
                <mat-label> {{ "SETTINGS.Sprache" | translate }}</mat-label>
                <mat-select [formControl]="languageForm">
                    <mat-option value="de">Deutsch</mat-option>
                    <mat-option value="fr">Französisch</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.berechtigungen" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="userHasGroups">
                {{ "MAIN_APP_SETTINGS.zugeordneteBenutzergruppen" | translate }}
                <mat-list>
                    <mat-list-item *ngFor="let group of dbBenutzerGruppen">
                        <mat-icon>arrow_right</mat-icon>
                        {{ group.gruppe }}
                    </mat-list-item>
                </mat-list>
            </div>
            <div class="control-section">
                <ejs-grid #gridRechte [dataSource]="dataSourceBenutzerRechte" [allowSorting]="true" [allowGrouping]="true" [groupSettings]="groupOptions" [sortSettings]="sortOptions" height="300">
                    <e-columns>
                        <e-column field="GroupOrder" headerText="Rechtegruppe">
                            <ng-template #groupSettingsCaptionTemplate let-data>
                                {{ groupTemplateFn(data) }}
                            </ng-template>
                        </e-column>

                        <e-column field="Rechtbeschreibung" headerText="Berechtigung"></e-column>
                        <e-column field="HatRecht" headerText="Benutzer" type="boolean" textAlign="Center">
                            <ng-template #template let-data>
                                <div>
                                    <ejs-checkbox #checkbox [checked]="data.HatRecht" [disabled]="true"></ejs-checkbox>
                                </div>
                            </ng-template>
                        </e-column>
                        <e-column field="HatRecht" headerText="Gruppe" type="boolean" textAlign="Center" [visible]="userHasGroups">
                            <ng-template #template let-data>
                                <div>
                                    <ejs-checkbox #checkbox [checked]="data.HatGruppenRecht" [disabled]="true"></ejs-checkbox>
                                </div>
                            </ng-template>
                        </e-column>
                        <e-column field="HatRecht" headerText="Effektiv" type="boolean" textAlign="Center" [visible]="userHasGroups">
                            <ng-template #template let-data>
                                <div>
                                    <ejs-checkbox #checkbox [checked]="data.HatEffektivRecht" [disabled]="true"></ejs-checkbox>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.backup" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="backup">
                <div class="download btn" (click)="downloadBackup()">
                    {{ "MAIN_APP_SETTINGS.downloadBackup" | translate }}
                </div>

                <div style="display: flex; flex-direction: row;">
                    <div style="display: flex;">
                        <div class="upload" #vinbkupUpload style="flex: 1; display: flex;">
                            <label for="vinbkInput" style="margin: auto; align-self: center;">{{ getBackupFilePath }}</label>
                            <input id="vinbkInput" #vinbkInput type="file" (change)="onChange($event)" style="height: 100%; width:100%; opacity: 0; position: absolute; left: 0; top: 0; right: 0; bottom: 0;" (drop)="onDrop($event);"
                                   (dragover)="onDragOver($event)">
                        </div>
                    </div>
                    <button (click)="loadBackup()" class="btn badFile" #vinbkApply (drop)="onDrop($event);" (dragover)="onDragOver($event)">
                        {{
                            vinbkInput.value ? ("MAIN_APP_SETTINGS.applyBackup" | translate) : ("MAIN_APP_SETTINGS.uploadBackup" |
                                translate)
                        }}
                    </button>
                </div>
            </div>
            <a id="downloadAnchorElem"></a>
        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header class="block2_title">
                {{ "MAIN_APP_SETTINGS.DEVICE_SETTINGS.TITLE" | translate }}
            </mat-expansion-panel-header>
            <div> {{ device.ua }}</div>
            <div> {{ device.device.model }} | {{ device.device.type }}</div>
            <div> {{ device.browser.name }} | {{ device.browser.version }}</div>
            <div> {{ device.device.orientation }} | H: {{ device.device.height }} X W: {{ device.device.width }}</div>
        </mat-expansion-panel>
    </mat-accordion>

    <div *ngIf="blocked" style="display: flex; position: absolute; top: 0; right: 0; left: 0; bottom: 0; background-color: rgba(55, 53, 53, 0.5);">
        <mat-spinner style="align-self: center; margin: auto;"></mat-spinner>
        <div>{{ blockedInfo }}</div>
    </div>
</main>
